import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { guid } from "@app/Guid"
    import { useId } from '@common/composables'
    import { useAdminConfigureConnectorPage } from '@Integrations/Connectors/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigureConnectorPage',
  setup(__props) {

    document.title = "Configure connector"

    const id = useId()
    const { useCurrentUserQuery, useConnectorProvidersQuery, useConnectorDetailsQuery, useConfigureConnectorCommand } = useAdminConfigureConnectorPage()

    const connectorProviderElement = ref<HTMLIFrameElement>(null)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runConnectorDetailsQueryV1, modelConnectorDetailsQueryV1 } = useConnectorDetailsQuery(id)
    const tid = computed(() => modelConnectorDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelConnectorDetailsQueryV1.value?.Name)
    const configPageUrl = computed(() => `${provider.value?.ConfigPageUrl}${tid.value}`)
    const connectorProviderType = computed(() => modelConnectorDetailsQueryV1.value?.ConnectorProvider?.Type)
    const connectorConfig = computed(() => modelConnectorDetailsQueryV1.value?.Config)

    const { runConnectorProvidersQueryV1, modelConnectorProvidersQueryV1 } = useConnectorProvidersQuery(true, true)

    const { invokeConfigureConnectorCommandV1, providerType, config, succeedConfigureConnectorCommandV1 } = useConfigureConnectorCommand(id, tid, userId)

    const connectorId = computed(() => modelConnectorDetailsQueryV1.value?.ConnectorId || guid())
    const providers = computed(() => modelConnectorProvidersQueryV1.value?.Providers)
    const provider = computed(() => providers.value?.find(_ => _.Type == providerType.value))

    watch(connectorProviderType, (val) => {
        providerType.value = connectorProviderType.value
    })

    watch(tid, (val) => {
        runConnectorProvidersQueryV1()
    })

    watch(succeedConfigureConnectorCommandV1, () => {
        if (succeedConfigureConnectorCommandV1.value) location.href = `/#/admin/integrations/connectors/details/${id}`
    })

    function onMessage(event) {
        if ((event.source as any)?.frameElement?.name == 'connectorProviderElement') {
            if (event.data?.type == 'Integrations.Connectors.ReadConfig') {
                // set current config once connector iframs is ready
                connectorProviderElement.value?.contentWindow?.postMessage({
                    'type': 'Integrations.Connectors.InitConfig',
                    'data': connectorConfig.value
                })
            }
            else if (event.data?.type == 'Integrations.Connectors.ApplyConnectorConfig') {
                config.value = JSON.stringify(event.data.data);
                invokeConfigureConnectorCommandV1()
            }
        }
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorDetailsQueryV1()
        window.addEventListener('message', onMessage);
    })

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    })

return { __sfc: true,id, useCurrentUserQuery, useConnectorProvidersQuery, useConnectorDetailsQuery, useConfigureConnectorCommand, connectorProviderElement, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runConnectorDetailsQueryV1, modelConnectorDetailsQueryV1, tid, name, configPageUrl, connectorProviderType, connectorConfig, runConnectorProvidersQueryV1, modelConnectorProvidersQueryV1, invokeConfigureConnectorCommandV1, providerType, config, succeedConfigureConnectorCommandV1, connectorId, providers, provider, onMessage }
}

})